<template>
  <div class="change-transaction-category-popup">
    <colored-popup :class="categoryToVariant[selectedCategory.cashflowCategory]" :close-action="close">

      <template v-slot:top-content>
        <div class="transaction-title">
          <span class="name">{{ incomeOrExpense }} {{ selectedCategory.label }}</span>
        </div>
        <transaction-details :transaction="transaction" />
      </template>

      <template v-slot:bottom-content>
        <div class="question">איזו {{ incomeOrExpense }} זו?</div>
        <cashflow-category-radio-list :options="transaction.splitFrom ? splitAvailableCategoriesWithoutSavings : availableCategories"
                                      :first-selected="selectedCategory"
                                      @select="onSelection"/>
        <text-input class='margin-top-xl'
                    :value="comment"
                    label-text="הערה"
                    :on-input="onInput"/>
        <riseup-button @click="onSave"
                       title="שמירה"
                       :disabled="shouldDisable"/>
      </template>
    </colored-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import BaseUI from '@riseupil/base-ui';
import * as _ from 'lodash';
import TransactionDetails from './TransactionDetails.vue';
import Segment from '../../../../../../../../../../Segment';
import cashflowViewConsts from '../../../../../../../../../../constants/cashflow-view';

export default {
  name: 'ChangeTransactionCategoryPopup',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    TransactionDetails,
    CashflowCategoryRadioList: BaseUI.CashflowCategoryRadioList,
    RiseupButton: BaseUI.RiseupButton,
    TextInput: BaseUI.TextInput,
  },
  data() {
    return {
      comment: null,
    };
  },
  created() {
    Segment.trackUserInteraction('ChangeTransactionCategoryPopup_Shown', {
      businessName: this.transaction.businessName,
      originalCategory: this.transaction.expense,
      transactionId: this.transaction.transactionId,
      isPlanAheadTransaction: !!this.transaction?.plan,
    });
    this.comment = this.customerComment;
  },
  computed: {
    ...mapState('editTransaction', ['transaction', 'selectedCategoryName', 'originalCategoryName']),
    ...mapGetters('editTransaction', [
      'sameCategorySelected', 'selectedCategory', 'availableCategories', 'splitAvailableCategories',
      'categoryToVariant', 'originalCategory', 'incomeOrExpense',
    ]),
    ...mapGetters('featureFlags', ['commentAndMoveTransaction']),
    splitAvailableCategoriesWithoutSavings() {
      return _.reject(this.splitAvailableCategories, item => item.isSaving);
    },
    customerComment() {
      return this.transaction.customerComment || '';
    },
    shouldDisable() {
      return this.sameCategorySelected && !this.commentChanged;
    },
    commentChanged() {
      return this.comment !== this.customerComment;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal', 'closeAllModals']),
    ...mapActions('editCashflow', ['setComment']),
    ...mapMutations('editTransaction', ['setSelectedCategoryName', 'setSelectedCategoryId']),
    close() {
      Segment.trackUserInteraction('ChangeTransactionCategoryPopup_CloseClicked', {
        businessName: this.transaction.businessName,
        originalCategory: this.transaction.expense,
        transactionId: this.transaction.transactionId,
      });
      this.closeAllModals();
    },
    onSelection(category) {
      if (category.categoryName === cashflowViewConsts.CATEGORY_NAMES.TRACKING || category.planAheadCategory) {
        this.setSelectedCategoryId(category.categoryId);
      } else {
        this.setSelectedCategoryName(category.categoryName);
      }
    },
    onInput(comment) {
      this.comment = comment;
    },
    changeCategory() {
      Segment.trackUserInteraction('ChangeTransactionCategoryPopup_SaveClicked', {
        businessName: this.transaction.businessName,
        originalCategory: this.transaction.expense,
        selectedCategory: this.selectedCategory.expense,
        transactionId: this.transaction.transactionId,
        isPlanAheadCategory: this.selectedCategory.planAheadCategory,
      });
      this.$emit('close');
      this.openModal({
        component: this.originalCategory.confirmationPopup || this.selectedCategory.targetPopup,
        props: {},
      });
    },
    async saveTransactionComment() {
      await this.setComment({ transactionId: this.transaction.transactionId, comment: this.comment });
      this.transaction.customerComment = this.comment;
      this.$emit('close');
    },
    onSave() {
      Segment.trackUserInteraction('ChangeTransactionWithComment', {
        changeCategory: !this.sameCategorySelected,
        changeComment: this.commentChanged,
      });
      if (!this.sameCategorySelected) {
        this.changeCategory();
      }
      if (this.commentChanged) {
        this.saveTransactionComment();
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.change-transaction-category-popup {
  text-align: right;

  .colored-top {

    .transaction-title {
      margin-bottom: 16px;
      line-height: 11px;

      .name, .dot{
        font-weight: bold;
      }
    }
  }

  .bottom {
    .question {
      color: $riseup_black;
      line-height: 13px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .cashflow-category-dropdown-v2 {
      margin-bottom: 40px;
    }

    .riseup-button {
      width: 100%;
    }
  }
}

</style>
